module.exports = __webpack_public_path__ + "img/xcx.ef6ddc64.png";